"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStoreRedux = void 0;
const storage_adapter_1 = require("./storage-adapter");
class LocalStoreRedux {
    constructor(storeName) {
        this.storeName = storeName;
        this.filterStorage = new storage_adapter_1.default(this.storeName, storage_adapter_1.default.types.LOCAL_STORAGE);
    }
    saveLocalState(state) {
        try {
            const { compareVehicleIds, lastVisitedVehicleIds, favoriteVehiclesIds, filterParams, aoz, resultVehicleIds, totalCount, sorting, } = state;
            this.filterStorage.writeEntry({
                compareVehicleIds,
                lastVisitedVehicleIds,
                favoriteVehiclesIds,
                filterParams,
                aoz,
                resultVehicleIds,
                totalCount,
                sorting,
            });
        }
        catch (e) {
            console.warn(e);
        }
    }
    getLocalState() {
        try {
            return this.filterStorage.readEntry();
        }
        catch (e) {
            console.warn(e);
            return undefined;
        }
    }
}
exports.LocalStoreRedux = LocalStoreRedux;
//# sourceMappingURL=localStoreRedux.js.map